// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"177":"09881165","834":"6184b144"}[chunkId] + ".chunk.js";
};